import { Loader } from '@pocketlaw/tetris';
import { LoaderContainer } from './styled';
export function WidgetLoader() {
    return (<LoaderContainer>
      <Loader size={16}/>
    </LoaderContainer>);
}
